import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { contestsBackend } from './contests.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { contestsReducer } from './contests.reducer';

// FIXME: remove that
backend.contests = contestsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('contests', contestsReducer),
    /* DatastoreBackendModule.forFeature(
      'contests',
      contestsBackend,
    ),*/
  ],
})
export class DatastoreContestsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contests/contests.module.ts